import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config';
import './InquiriesManager.css';

const STATUSES = ['ALL', 'NEW', 'CONTACTED', 'ARCHIVED'];

export default function InquiriesManager() {
  const { authenticatedFetch } = useAuth();
  const [filter, setFilter] = useState('NEW');
  const [rows, setRows] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [counts, setCounts] = useState({ NEW: 0, CONTACTED: 0, ARCHIVED: 0 });

  async function load() {
    const q = filter === 'ALL' ? '' : `?status=${filter}`;
    const res = await authenticatedFetch(`${API_BASE_URL}/api/inquiries${q}`);
    setRows(res.ok ? await res.json() : []);
  }
  async function loadCounts() {
    const all = await authenticatedFetch(`${API_BASE_URL}/api/inquiries`);
    if (!all.ok) return;
    const list = await all.json();
    const c = { NEW: 0, CONTACTED: 0, ARCHIVED: 0 };
    list.forEach((r) => { c[r.status] = (c[r.status] || 0) + 1; });
    setCounts(c);
  }
  useEffect(() => { load(); loadCounts(); }, [filter]);

  async function setStatus(id, status) {
    await authenticatedFetch(`${API_BASE_URL}/api/inquiries/${id}`, {
      method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status }),
    });
    load(); loadCounts();
  }
  async function remove(id) {
    if (!window.confirm('Delete this inquiry?')) return;
    await authenticatedFetch(`${API_BASE_URL}/api/inquiries/${id}`, { method: 'DELETE' });
    load(); loadCounts();
  }

  return (
    <div className="inquiries-manager">
      <div className="inquiries-head">
        <h2>Inquiries</h2>
        <div className="inquiries-filters">
          {STATUSES.map((s) => (
            <button key={s} className={`chip ${filter === s ? 'active' : ''}`} onClick={() => setFilter(s)}>
              {s}{s !== 'ALL' && ` (${counts[s] ?? 0})`}
            </button>
          ))}
        </div>
      </div>
      <table className="inquiries-table">
        <thead><tr><th>Date</th><th>Name</th><th>Email</th><th>Service</th><th>Status</th><th>Email</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <React.Fragment key={r.id}>
              <tr onClick={() => setExpanded(expanded === r.id ? null : r.id)} className={expanded === r.id ? 'expanded' : ''}>
                <td>{new Date(r.createdAt).toLocaleDateString()}</td>
                <td>{r.name}</td>
                <td>{r.email}</td>
                <td>{r.preferredService || '—'}</td>
                <td><span className={`status status-${r.status}`}>{r.status}</span></td>
                <td>{r.emailSentAt ? '✓' : (r.emailError ? '✗' : '…')}</td>
              </tr>
              {expanded === r.id && (
                <tr className="inquiry-detail">
                  <td colSpan="6">
                    <div className="detail-grid">
                      <div><b>Phone:</b> {r.phone || '—'}</div>
                      <div><b>Preferred time:</b> {r.preferredTime || '—'}</div>
                      <div><b>IP:</b> {r.ipAddress || '—'}</div>
                      <div><b>User agent:</b> {r.userAgent || '—'}</div>
                      {r.emailError && <div className="email-error"><b>Email error:</b> {r.emailError}</div>}
                      {r.emailSentAt && <div><b>Email sent:</b> {new Date(r.emailSentAt).toLocaleString()}</div>}
                    </div>
                    <div className="detail-message"><b>Message</b><pre>{r.message}</pre></div>
                    <div className="detail-actions">
                      {r.status !== 'CONTACTED' && <button className="btn-primary" onClick={() => setStatus(r.id, 'CONTACTED')}>Mark Contacted</button>}
                      {r.status !== 'ARCHIVED' ? <button className="btn-secondary" onClick={() => setStatus(r.id, 'ARCHIVED')}>Archive</button> : <button className="btn-secondary" onClick={() => setStatus(r.id, 'NEW')}>Unarchive</button>}
                      <button className="btn-danger" onClick={() => remove(r.id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
          {rows.length === 0 && <tr><td colSpan="6" style={{ color: 'var(--color-text-muted)' }}>No inquiries match this filter.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
